import { render, staticRenderFns } from "./SellRecordDetail.vue?vue&type=template&id=4382d4b9&lang=pug&"
import script from "./SellRecordDetail.vue?vue&type=script&lang=js&"
export * from "./SellRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./SellRecordDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports